module.exports = __webpack_public_path__ + "img/13.58d8434d.png";